var _path, _path2, _path3, _path4, _path5, _path6, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQoutationsDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 102,
    viewBox: "0 0 75 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8C4.5 6.89543 5.39543 6 6.5 6H62.5L67.5 11.76L74.5 18V100C74.5 101.105 73.6046 102 72.5 102H6.5C5.39543 102 4.5 101.105 4.5 100V8Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 6L68.5 12L74.5 18H63.5C62.9477 18 62.5 17.5523 62.5 17V6Z",
    fill: "#BBB8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 49C14.5 48.4477 14.9477 48 15.5 48H63.5C64.0523 48 64.5 48.4477 64.5 49V58H14.5V49Z",
    fill: "#4187B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 58H64.5V74C64.5 75.1046 63.6046 76 62.5 76H38.5V58Z",
    fill: "#19CFBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 58H39.5V76H16.5C15.3954 76 14.5 75.1046 14.5 74V58Z",
    fill: "#FFBF31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.937 92C40.1881 90.2682 40.1003 85.9471 43.1592 88.3611C44.1658 89.1555 46.6607 93.7855 48.187 91.8611C48.8448 91.0317 48.7866 89.6504 49.4925 88.9444C51.7264 86.7106 55.5649 88.9516 57.8814 89.6389C59.8701 90.2289 62.7426 87.9939 64.2425 86.9167C64.7234 86.5714 65.0664 86 65.687 86",
    stroke: "#4187B5",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 19,
    fill: "#FFB454"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5982_806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.094 21.798C24.094 22.502 23.918 23.1767 23.566 23.822C23.214 24.4527 22.6933 24.9807 22.004 25.406C21.3293 25.8313 20.5153 26.0733 19.562 26.132V27.914H18.374V26.132C17.0393 26.0147 15.954 25.5893 15.118 24.856C14.282 24.108 13.8567 23.162 13.842 22.018H15.976C16.0347 22.634 16.262 23.1693 16.658 23.624C17.0687 24.0787 17.6407 24.3647 18.374 24.482V18.982C17.3913 18.7327 16.5993 18.476 15.998 18.212C15.3967 17.948 14.8833 17.5373 14.458 16.98C14.0327 16.4227 13.82 15.6747 13.82 14.736C13.82 13.548 14.2307 12.5653 15.052 11.788C15.888 11.0107 16.9953 10.578 18.374 10.49V8.664H19.562V10.49C20.8087 10.5927 21.8133 10.996 22.576 11.7C23.3387 12.3893 23.7787 13.2913 23.896 14.406H21.762C21.6887 13.8927 21.4613 13.4307 21.08 13.02C20.6987 12.5947 20.1927 12.316 19.562 12.184V17.552C20.53 17.8013 21.3147 18.058 21.916 18.322C22.532 18.5713 23.0453 18.9747 23.456 19.532C23.8813 20.0893 24.094 20.8447 24.094 21.798ZM15.866 14.626C15.866 15.3447 16.0787 15.8947 16.504 16.276C16.9293 16.6573 17.5527 16.9727 18.374 17.222V12.14C17.6113 12.2133 17.0027 12.4627 16.548 12.888C16.0933 13.2987 15.866 13.878 15.866 14.626ZM19.562 24.504C20.354 24.416 20.97 24.13 21.41 23.646C21.8647 23.162 22.092 22.5827 22.092 21.908C22.092 21.1893 21.872 20.6393 21.432 20.258C20.992 19.862 20.3687 19.5467 19.562 19.312V24.504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5982_806",
    x: 9.82031,
    y: 8.66406,
    width: 18.2734,
    height: 27.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5982_806"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5982_806",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoutationsDash);
export default __webpack_public_path__ + "static/media/qoutationsDash.d2ba4c3c663eea6e0ee4a5183db6545b.svg";
export { ForwardRef as ReactComponent };